import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

import { INumberField } from '@shared/interfaces';

@Component({
  selector: 'app-number-section',
  templateUrl: './number-section.component.html',
  styleUrls: ['./number-section.component.scss'],
  standalone: false,
})
export class NumberSectionComponent implements OnInit {
  @Input() numberSection: INumberField;
  @Input() control: FormControl;
  @Output() valueChange = new EventEmitter<any>();

  ngOnInit(): void {
    if (this.numberSection.isRequired) {
      this.control.setValidators([Validators.required]);
      this.control.updateValueAndValidity();
    }

    // Emit whenever value changes
    this.control.valueChanges.subscribe((val) => {
      this.valueChange.emit(val);
    });
  }
}
